import NetworkingOperations from "../index";

const BalanceUsage = () => {
	const url = process.env.REACT_APP_BALANCE_USAGE;

	return NetworkingOperations.get({ url }).then((res) => res);
};

export default BalanceUsage;
